import AdminZoomSettings from './AdminZoomSettings';

export default AdminZoomSettings;
